export function contestRules() {
    let cascadeItems = $('.cascade-item-info');
    if (cascadeItems.length) {
        cascadeItems.each(function () {
            $(this).find(".slider-images").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                dots: false,
                autoplay: true,
                autoplaySpeed: 3000
            });
        });
    }

    let $holderSlider = $('.holder-slider-contest-rules');
    if ($holderSlider.length) {
        let $slider = $holderSlider.find(".slider");
        let $sliderItems = $holderSlider.find(".item-slide").length;

        function sliderInit() {
            $slider.slick({
                infinite: false,
                slidesToShow: 5,
                slidesToScroll: 1,
                prevArrow: $holderSlider.find(".common-slider-controls .prev-arrow"),
                nextArrow: $holderSlider.find(".common-slider-controls .next-arrow"),
                responsive: [
                    {
                        breakpoint: 1920,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: "unslick"
                    },
                ]
            });
        }

        $(window).on("load resize", function () {
            if (window.innerWidth >= 1024 && !$slider.hasClass("slick-initialized")) {
                sliderInit();
            }

            if ($slider.hasClass("slick-initialized")) {
                if ((window.innerWidth >= 1024 && window.innerWidth < 1920 && $sliderItems <= 3) || (window.innerWidth >= 1920 && $sliderItems <= 5)) {
                    $holderSlider.find(".common-slider-controls").hide();
                }
            }
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/contest-rules.js